document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuOpenButton = document.querySelector('.js-mobile-menu-open');
    if (!mobileMenuOpenButton) return;

    const hamburgerIcon = mobileMenuOpenButton.querySelector('.js-icon-hamburger');
    const closeIcon = mobileMenuOpenButton.querySelector('.js-icon-close');
    const mobileMenuId = mobileMenuOpenButton.getAttribute('aria-controls');

    const mobileMenu = document.getElementById(mobileMenuId);
    if (!mobileMenu) return;

    const focusableSelector = 'a, button, [tabindex]:not([tabindex="-1"])';

    const openMobileMenu = () => {
        // Update button
        mobileMenuOpenButton.classList.add('menu-expanded');
        mobileMenuOpenButton.setAttribute('aria-expanded', 'true');
        if( hamburgerIcon && closeIcon ) {
            hamburgerIcon?.setAttribute('aria-hidden', 'true');
            hamburgerIcon.hidden = true;
            closeIcon?.setAttribute('aria-hidden', 'false');
            closeIcon.hidden = false;
        }

        // Update menu
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenu.hidden = false;
        mobileMenu.focus(); 
    }

    const closeMobileMenu = () => {
        // Update button
        mobileMenuOpenButton.classList.remove('menu-expanded');
        mobileMenuOpenButton.setAttribute('aria-expanded', 'false');
        if( hamburgerIcon && closeIcon ) {
            hamburgerIcon?.setAttribute('aria-hidden', 'false');
            hamburgerIcon.hidden = false;
            closeIcon?.setAttribute('aria-hidden', 'true');
            closeIcon.hidden = true;
        }

        // Update menu
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenu.hidden = true;
        mobileMenu.blur(); 
    }

    const toggleMobileMenu = () => {
        if( mobileMenuOpenButton.classList.contains('menu-expanded') ) {
            closeMobileMenu()
        } else {
            openMobileMenu()
        }
    }

    mobileMenuOpenButton.addEventListener('click', () => {
        toggleMobileMenu(mobileMenuOpenButton);
    })

    document.addEventListener('keydown', (event) => {
        if (
        event.key === 'Escape' &&
            mobileMenuOpenButton.getAttribute('aria-expanded') === 'true'
        ) {
            closeMobileMenu();
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.js-header');
    const announcementBar = document.querySelector('.js-announcement-bar');

    const setHeaderHeight = () => {
        if( header ) {
            const headerHeight = header.offsetHeight;
            const headerHeightPx = headerHeight + 'px';
            document.documentElement.style.setProperty('--header-height', headerHeightPx);
        }
    }

    const setAnnouncementBarHeight = () => {
        if( announcementBar ) {
            const announcementBarHeight = announcementBar.offsetHeight;
            const announcementBarHeightPx = announcementBarHeight + 'px';
             document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeightPx);
        }
    }

    const calculateHeaderHeight = () => {
        if( header ) {
            const newHeaderHeight = header.offsetHeight;
            const newHeaderHeightPx = newHeaderHeight + 'px';
            const currentHeaderHeight = document.documentElement.style.getPropertyValue('--header-height')

            if (newHeaderHeightPx !== currentHeaderHeight) {
                document.documentElement.style.setProperty('--header-height', newHeaderHeightPx);
            }
        }
    }

    const calculateAnnouncementBarHeight = () => {
        if( announcementBar ) {
            const newAnnouncementBarHeight = announcementBar.offsetHeight;
            const newAnnouncementBarHeightPx = newAnnouncementBarHeight + 'px';
            const currentAnnouncementBarHeight = document.documentElement.style.getPropertyValue('--announcement-bar-height')

            if (newAnnouncementBarHeightPx !== currentAnnouncementBarHeight) {
                document.documentElement.style.setProperty('--announcement-bar-height', newAnnouncementBarHeightPx);
            }
        }
    }

    setHeaderHeight();
    setAnnouncementBarHeight();

    window.addEventListener('resize', () => {
        calculateHeaderHeight();
        calculateAnnouncementBarHeight();
    })
});

document.addEventListener('DOMContentLoaded', () => {
    const productAlertClose = document.querySelector('[data-product-alert-close');

    productAlertClose.addEventListener('click', () => {
        const productAlert = productAlertClose.closest('[data-product-alert]');
        productAlert.hidden = true;
        productAlert.classList.remove('alert-error');
    })
})